// NOTICE: This file was copied from the oppizi-shared repository, do
// not modify it here.

import _ from 'lodash'

const round = (number, precision = 2) => _.round(number, precision)
const ratioToPercent = ratio => {
  const parse = parseFloat(ratio)
  return isNaN(parse) ? null : round(parse * 100)
}

const roundDecimal = (value, step = 0.5) => {
  const inv = 1.0 / step
  return Math.round(value * inv) / inv
}

/**
 * Get the closest matching number from an array given a goal number
 * Taken from: https://stackoverflow.com/a/19277804/837649
 * @param {Array<number>} counts
 * @param {number} goal
 * @returns {number}
 */
const closest = (counts, goal) =>
  counts.reduce(function(prev, curr) {
    return Math.abs(curr - goal) < Math.abs(prev - goal) ? curr : prev
  })

/**
 * Get rounded value with 2 decimals
 * @param {number}
 * @returns {number}
 */
const roundTwoDecimals = value => {
  return Math.round(value * 100) / 100
}

export { ratioToPercent, round, roundDecimal, closest, roundTwoDecimals }



// WEBPACK FOOTER //
// ./src/shared/libraries/utils/number.js